<template>
  <v-container fluid style="background: #eaedf1">
    <v-sheet class="pa-3" v-if="superUser || getPermission('rewards.read')">
      <v-toolbar flat height="80">
        <v-btn
          v-if="superUser || getPermission('rewards.create')"
          color="secondary"
          class="text-capitalize px-5"
          depressed
          v-text="translations.createNewReward[lang]"
          @click="startCreateNewReward"
        ></v-btn>

        <v-spacer></v-spacer>

        <v-col cols="12" sm="4" class="pt-3">
          <b-search-field v-model="search"></b-search-field>
        </v-col>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :loading="loading"
        :items="rewards"
        :footer-props="{
          itemsPerPageOptions: [12],
          showCurrentPage: true,
          pageText: `${page * 12 - 11}-${
            page * 12 <= serverItemsLength ? page * 12 : serverItemsLength
          } ${translations.paginationText[lang]} ${serverItemsLength}`,
        }"
        :page.sync="page"
        :server-items-length="serverItemsLength"
        class="b-outlined rounded-0"
      >
        <template v-slot:item.title="{ item }">
          <router-link
            v-if="superUser || getPermission('rewards.update')"
            :to="{ name: 'New Reward' }"
            event=""
            class="b-signin-link"
            @click.native.prevent="startCreateNewReward(item)"
          >
            <span class="font-weight-bold px-1">{{ item.title }}</span>
          </router-link>
          <span v-else class="font-weight-bold px-1">{{ item.title }}</span>
        </template>
        <template v-slot:item.points="{ item }">
          <span class="font-weight-bold px-1" v-text="item.points || '-'"></span>
        </template>

        <template v-slot:item.coupons="{ item }">
          <div v-if="item.coupons[0]">
            {{ item.coupons[0].gift_title }}
            <span v-if="item.coupons[1]" class="ml-n1">
              <v-tooltip color="secondary" top>
                <template v-slot:activator="{ on }">
                  <v-btn color="secondary" icon v-on="on">
                    <v-icon v-text="icons.mdiDotsHorizontal"></v-icon>
                  </v-btn>
                </template>
                <span v-for="(item, index) in item.coupons" :key="index" class="font-weight-bold">
                  <span v-if="index > 1">{{ ', ' }}</span
                  ><span v-if="index"> {{ item.gift_title }}</span>
                </span>
              </v-tooltip>
            </span>
          </div>
          <div v-else>-</div>
        </template>
        <template v-slot:item.system_notification_ids="{ item }">
          <div class="d-flex">
            <span
              v-for="(notification, index) in filterCampaignChannels(item.system_notification_ids)"
              :key="index"
              class="font-weight-bold px-1 d-flex align-center"
            >
              <v-icon
                v-if="index && item.notifier_type && item.notifier_type == 'priority'"
                size="18"
                class="ml-n2 mr-1"
                v-text="icons.mdiArrowRight"
                color="secondary"
              ></v-icon>
              <Icon
                v-if="notification.channel == 'viber'"
                icon="simple-icons:viber"
                color="secondary"
                :style="{
                  fontSize: '20px',
                }"
              />
              <v-icon
                v-else
                v-text="notificationIcons[notification.channel]"
                color="secondary"
              ></v-icon>
            </span>
          </div>
        </template>
        <!-- <template v-slot:item.created_at="{ item }">
                    <span
                                class="font-weight-bold px-1"
                            >{{ localizeDate(item.created_at, true) }}</span>
                </template> -->
        <template v-slot:item.actions="{ item }">
          <v-tooltip color="secondary" top>
            <template v-slot:activator="{ on }">
              <v-btn
                color="red"
                icon
                v-on="on"
                @click="
                  () => {
                    removingReward = item;
                    deleteDialog = true;
                  }
                "
              >
                <v-icon v-text="icons.mdiClose"></v-icon>
              </v-btn>
            </template>

            <span class="font-weight-bold" v-text="translations.delete[lang]"></span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-sheet>
    <v-dialog v-model="deleteDialog" max-width="500">
      <b-card
        type="delete"
        :title="translations.deleteReward[lang]"
        :submit-text="translations.delete"
        :loading="loading"
        :error-message="errorMessage"
        @cancel="deleteDialog = false"
        @submit="deletingReward(removingReward)"
      >
        <div class="subtitle-1 font-weight-medium pt-2 px-2">
          {{ translations.deleteConfirmationMessage[lang] }}
          <span class="font-weight-bold text--primary">{{ deleteReward.title }}</span
          >{{ translations.questionmark[lang] }}
        </div>
      </b-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {
  mdiCalendarMonth,
  mdiChat,
  mdiBell,
  mdiEmail,
  mdiLock,
  mdiEye,
  mdiCached,
  mdiEmailOutline,
  mdiMessageReplyTextOutline,
  mdiMessageTextOutline,
  mdiBellOutline,
  mdiArrowRight,
  mdiCancel,
  mdiPlay,
  mdiClose,
  mdiDotsHorizontal,
} from '@mdi/js';
import { mapMutations, mapState, mapActions } from 'vuex';

// import AdditionalInfo from "@/components/loyaltyPanel/viewCampaigns/AdditionalInfo";
import translations from '@/utils/translations/loyaltyPanel/campaigns/viewRewards';
import debounce from 'lodash/debounce';
import { Icon } from '@iconify/vue2';

export default {
  name: 'ViewRewards',

  mixins: [translations],

  components: {
    Icon,
  },

  data() {
    return {
      icons: {
        mdiCalendarMonth,
        mdiChat,
        mdiBell,
        mdiEmail,
        mdiLock,
        mdiEye,
        mdiCached,
        mdiEmailOutline,
        mdiMessageReplyTextOutline,
        mdiMessageTextOutline,
        mdiBellOutline,
        mdiArrowRight,
        mdiCancel,
        mdiPlay,
        mdiClose,
        mdiDotsHorizontal,
      },
      itemsPerPageOptions: [10, 20, 30, -1],
      page: +this.$route.query.page,
      // changingStatusCampaignId: null,
      dialogStatusSystem: null,
      statusDialogData: {
        open: false,
        title: '',
        description: '',
        campaign: {},
        theme: '',
        action: () => {},
      },
      removingReward: {},
      newStatus: null,
      additionalDialog: false,
      search: '',
      status: +this.$route.query.status || null,
      notificationIcons: {
        sms: mdiMessageTextOutline,
        mail: mdiEmailOutline,
        push: mdiBellOutline,
        viber: 'simple-icons:viber',
      },
      deleteDialog: false,
    };
  },

  computed: {
    ...mapState([
      'loading',
      'errorMessage',
      'serverItemsLength',
      'permissions',
      'storePermissions',
      'superUser',
      'isSuperAdmin',
    ]),
    ...mapState('loyaltyPanel/campaigns/rewards', [
      'rewards',
      'campaignStatuses',
      'systemNotifications',
      'newReward',
    ]),

    lang() {
      return this.$route.params.lang;
    },
    locale() {
      if (this.lang == 'el') return 'el-GR';
      if (this.lang == 'it') return 'it-IT';
      return 'en-GB';
    },
    storeMode() {
      return this.$store.state.store?.display_mode || 'points';
    },
    // channels() {
    //     return this.systemNotifications.map( e => ({
    //         ...e,
    //         icon:
    //     }) )
    // },

    headers() {
      let headers = [
        {
          text: this.translations.rewardId[this.lang],
          value: 'reward_id',
          width: 200,
        },
        {
          text: this.translations.title[this.lang],
          value: `title`,
          width: 250,
        },
        {
          text: this.translations[this.storeMode][this.lang],
          value: 'points',
          width: 200,
        },
        {
          text: this.translations.coupons[this.lang],
          value: `coupons`,
          width: 200,
        },
        {
          text: this.translations.notifications[this.lang],
          value: 'system_notification_ids',
          width: 200,
        },
        // {
        //     text: this.translations.createdAt[this.lang],
        //     value: "coupon_notification",
        //     width: 200,
        // },
        // {
        //     text: this.translations.createdAt[this.lang],
        //     value: "created_at",
        //     width: 200,
        // },
        {
          text: this.translations.actions[this.lang],
          value: 'actions',
        },
      ];
      return headers;
    },

    query() {
      let query = '?';
      for (let key in this.$route.query) {
        if (this.$route.query[key]) {
          query += `${key}=${this.$route.query[key]}&`;
        }
      }
      return query.slice(0, query.length - 1);
    },
  },

  watch: {
    $route(val) {
      if (!val.query.page) {
        this.$router.replace({
          query: {
            page: 1,
            ...this.$route.query,
          },
        });
      }
      if (!val.query.q) {
        delete val.query.q;
      }
      this.getRewards({
        query: this.query,
        status: this.status ? `&status=${this.status}` : '',
      });
    },

    page(page) {
      this.$router.push({ query: { ...this.$route.query, page } });
    },

    search(val) {
      if (!val || val == null) {
        this.$route.query.q = undefined;
      }
      this.debouncedSearch();
    },

    status(val) {
      // this.getRewards({
      //     query: this.query,
      //     status: val ? `&status=${val}` : "",
      // });
      this.$router.push({
        query: { ...this.$route.query, status: val || undefined },
      });
    },
  },

  methods: {
    ...mapActions('loyaltyPanel/campaigns/rewards', [
      'getRewards',
      'getSystemNotifications',
      'deleteReward',
      'getRewardById',
    ]),
    ...mapMutations('loyaltyPanel/campaigns/rewards', [
      'setNewReward',
      'setStep',
      'setCanGoToNextStep',
      'setUploadingImage',
    ]),

    localizeDate(date, short) {
      return date
        ? new Date(date).toLocaleString(this.locale, {
            weekday: short ? undefined : 'long',
            year: 'numeric',
            month: short ? 'numeric' : 'long',
            day: 'numeric',
          })
        : '-';
    },

    filterChannels(ids) {
      return this.systemNotifications.filter((e) => ids.includes(e.system_notification_id));
    },

    handleSearch() {
      if (this.page != 1) {
        this.page = 1;
      } else {
        this.$router.push({
          query: { ...this.$route.query, q: this.search },
        });
        // this.getRewards({
        //     query: `?q=${this.search}`,
        //     status: this.status ? `&status=${this.status}` : "",
        // });
      }
    },

    async startCreateNewReward(reward = {}) {
      let rewardData = reward || {};
      if (rewardData.reward_id) {
        const fullReward = await this.getRewardById(rewardData.reward_id);
        rewardData = fullReward?.reward_id ? fullReward : rewardData;
        if (!rewardData.gift_ids && rewardData.coupons?.length) {
          rewardData.gift_ids = rewardData.coupons.map((e) => e.gift_id);
        }
        rewardData.coupon_ids = rewardData.gift_ids || [];
      }
      this.setNewReward(rewardData || {});
      this.setStep(1);
      this.setCanGoToNextStep(!!rewardData.reward_id || false);
      this.setUploadingImage(null);
      this.$nextTick(() => {
        this.$router.push(`/${this.lang}/loyaltyPanel/campaigns/new-reward`);
      });
    },

    getPermission(path) {
      return (
        this.superUser ||
        this.permissions['*'] ||
        (this.permissions.rewards &&
          this.permissions &&
          eval('this.permissions.' + path) &&
          eval('this.storePermissions.' + path))
      );
    },
    deletingReward(reward) {
      if (this.deleteReward(reward)) {
        this.deleteDialog = false;
      }
    },

    filterCampaignChannels(ids) {
      return this.systemNotifications.filter((e) => ids.includes(e.system_notification_id));
    },
  },

  mounted() {
    this.getRewards({
      query: this.query,
      status: this.status ? `&status=${this.status}` : '',
    });
    this.getSystemNotifications();
    if (this.$route.query.q) {
      this.search = this.$route.query.q;
    }
  },

  created() {
    this.debouncedSearch = debounce(this.handleSearch, 500);
    this.search = this.$route.query.q || '';
  },

  beforeCreate() {
    if (!this.$route.query.page) {
      this.$router.replace({
        query: {
          page: 1,
          ...this.$route.query,
        },
      });
    }
  },
};
</script>

<style scoped>
.b-outlined {
  border: 1px solid rgba(0, 0, 0, 0.12);
}
</style>
